import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectBrand } from '../redux/carDuck';
import { fetchToken, fetchBrands } from '../redux/apiDuck';
import { useHistory } from 'react-router-dom';
import ListItem from '../components/ListItem';
import List from '../components/List';
import Card from '../components/Card';
import Typography from '../components/Typography';
import Loader from '../components/Loader';
import Button from '../components/Button';

const preferredBrands = {
  11: '11', // CITROEN
  12: '12', // CHEVROLET
  17: '17', // FIAT
  18: '18', // FORD
  32: '32', // PEUGEOT
  36: '36', // RENAULT
  46: '46' // VW
};

export const FirstStep = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { token, brands, fetching } = useSelector((state) => state.api);
  const [viewMore, setViewMore] = useState(false);
  // const fetching = true;
  useEffect(() => {
    dispatch(fetchToken());
    dispatch(fetchBrands());
  }, [dispatch]);

  const handleSelectBrand = ({ codigo, descripcion }) => {
    dispatch(selectBrand(parseInt(codigo), descripcion));

    history.push('/modelos');
  };

  const handleClick = () => {
    setViewMore(!viewMore);
  };

  const filterBrands = () => {
    if (viewMore) return brands;

    return brands.filter(({ codigo }) => codigo === preferredBrands[codigo]);
  };

  if (!token || fetching) return <Loader />;

  return (
    <>
      <Typography text='¿Cúal es la marca de tu auto?' variant='h1' />
      <Card>
        <List>
          {filterBrands(brands).map((brand) => (
            <ListItem
              key={brand.codigo}
              text={brand.descripcion}
              handleClick={() => handleSelectBrand(brand)}
            />
          ))}
        </List>
      </Card>
      <Button
        text={viewMore ? 'Ver menos marcas' : 'Ver más marcas'}
        variant='outlined'
        onClick={handleClick}
      />
    </>
  );
};
